"use strict";
var assocIndexOf = require('./_assocIndexOf');
function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;
//# sourceMappingURL=_listCacheGet.js.map